import React from "react";
import { Container, Paper, Grid } from "@material-ui/core";
import Joi from "@hapi/joi";
import { withSnackbar } from "notistack";
import Form from "../../../common/form";
import Loading from "../../../common/loading";
import TitleComponent from "../../../common/titleComponent";
import Breadcrumb from "../../../common/breadcum";
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import { format } from "date-fns";
import { getProjectComponents } from "../../../../services/projectComponentService";
import {
  getActivity,
  saveActivity,
} from "../../../../services/activityService";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { formatDate } from "../../../../utils/constants";

class EditActivityForm extends Form {
  state = {
    data: {
      name: "",
      start_date: format(new Date(), formatDate.DATE),
      end_date: format(new Date(), formatDate.DATE),
      responsable: "",
      component_id: "",
    },
    projectComponents: [],
    errors: {},
    isLoading: false,
  };

  schema = Joi.object({
    id: Joi.number().integer(),
    name: Joi.string().label("Nombre"),
    start_date: Joi.string().max(500).label("Fecha Inicio"),
    end_date: Joi.string().max(500).label("Fecha Fin"),
    responsable: Joi.string().label("Responsable"),
    component_id: Joi.number().integer().label("Componente"),
  });

  async populateProjectComponents() {
    const projectSlug = this.props.match.params.slug;
    const { data: projectComponents } = await getProjectComponents(projectSlug);
    this.setState({ projectComponents });
  }

  async populateActivity() {
    try {
      const activityId = this.props.match.params.id; //Pasando por URL id movie
      if (activityId === "new") return; //Si si
      const { data: activity } = await getActivity(activityId); //Si no.
      this.setState({ data: this.mapToViewModel(activity) });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  async componentDidMount() {
    this.setState({ isLoading: true });
    await this.populateActivity();
    await this.populateProjectComponents();
    this.setState({ isLoading: false });
  }

  mapToViewModel(activity) {
    return {
      id: activity.id,
      name: activity.name,
      start_date: format(new Date(activity.start_date), formatDate.DATE),
      end_date: format(new Date(activity.end_date), formatDate.DATE),
      responsable: activity.responsable,
      component_id: activity.component_id,
    };
  }

  doSubmit = async () => {
    try {
      this.setState({ isLoading: true });
      await saveActivity(this.state.data);
      this.successMessage();
      // this.props.history.goBack();
    } catch (ex) {
      this.errorMessage(ex);
      const errors = { ...this.state.errors };
      if (ex.response && ex.response.status === 422) {
        errors.code = ex.response.data.errors.code;
        errors.name = ex.response.data.errors.name;
        errors.acronym = ex.response.data.errors.acronym;
        this.setState({ errors });
      }
      //console.log(ex.response.data.errors);
    } finally {
      this.setState({ isLoading: false });
    }
  };
  handleDateChange = (date, name) => {
    const data = { ...this.state.data };
    data[name] = format(date, "yyyy/MM/dd");
    this.setState({ data });
    // setState((prevState) => ({ ...prevState, data }));
    //setSelectedDate(date);
  };

  render() {
    const { isLoading, data, projectComponents } = this.state;
    // const optionsSelected = this.getLinesSelected();
    const listBreadcrumbs = [
      {
        path: "/proyectos",
        label: "Proyectos",
      },
      {
        path: "/proyecto/" + this.props.match.params.slug,
        label: this.props.match.params.slug,
      },
    ];

    return (
      <Container maxWidth="lg">
        <Loading open={isLoading} />
        <Breadcrumb
          onListBreadcrumbs={listBreadcrumbs}
          lastLabel={"Editar actividad"}
        />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={7} md={8}>
            <Paper className="paper">
              <TitleComponent entity={"Editar actividad"} />
              <form onSubmit={this.handleSubmit}>
                {this.renderInput("name", "Nombre")}

                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                  <Grid container justifyContent="space-around">
                    <DatePicker
                      margin="normal"
                      id="start_date"
                      label="Fecha de inicio *"
                      format={formatDate.DATE}
                      openTo="year"
                      views={["year", "month", "date"]}
                      variant="outlined"
                      value={data.start_date}
                      onChange={(date) =>
                        this.handleDateChange(date, "start_date")
                      }
                    />
                    <DatePicker
                      margin="normal"
                      id="end_date"
                      label="Fecha de fin *"
                      openTo="year"
                      views={["year", "month", "date"]}
                      format={formatDate.DATE}
                      variant="outlined"
                      value={data.end_date}
                      onChange={(date) =>
                        this.handleDateChange(date, "end_date")
                      }
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
                {this.renderInput("responsable", "Responsable")}
                {this.renderSelect(
                  "component_id",
                  "Componente",
                  75,
                  "id",
                  "name",
                  projectComponents
                )}

                {this.renderButton("Guardar")}
              </form>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    );
  }
}

export default withSnackbar(EditActivityForm);
